import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CurrentTaskInputModel } from '../current-task-input-model';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { CurrentTaskInputState } from '../../types';


@injectable()
export class CurrentTaskInputModelImpl extends AbstractModel<CurrentTaskInputState> implements CurrentTaskInputModel {
    protected _modelData: CurrentTaskInputState = {
        inputLanguage: undefined,
    };

    dispose(): void {
        this.update((state) => {
            state.inputLanguage = undefined;
            return state;
        });
    }
}
